export interface IListDataView {
    label: string;
    value: any;
    type: ListViewDataType;
}

export enum ListViewDataType {
    text = 'text',
    number = 'number',
    date = 'date',
    dateUtc = 'date_utc',
    dateTicks = 'date_ticks',
    dateUtcTicks = 'date_utc_ticks'
}